import React, {useState, MouseEvent} from 'react';

import {SimpleActionButton} from 'components/form/components';

import {IChangeHistoryData, ModalChangeHistory} from './modal-change-history/modal-change-history';

interface IButtonChangeHistoryProps{
    changeHistoryData?: IChangeHistoryData;
}
export const ButtonChangeHistory = ({changeHistoryData}: IButtonChangeHistoryProps) => {
    const [changeHistoryModalVisible, setChangeHistoryModalVisible] = useState(false);

    const handleClick = (e: MouseEvent<HTMLElement>) => {
        e.currentTarget?.blur();
        setChangeHistoryModalVisible(true);
    };

    return (
        <>
            <ModalChangeHistory
                visible={changeHistoryModalVisible}
                changeHistoryData={changeHistoryData}
                onClose={() => setChangeHistoryModalVisible(false)}
            />
            <SimpleActionButton
                type="ghost"
                icon="ClockCircleOutlined"
                title="История изменений"
                onClick={handleClick}
            />
        </>
    );
};
